export interface Faq {
  id: string
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    id: 'solo-florida',
    question: '¿Este servicio es solamente para negocios en Florida?',
    answer:
      'Esta propuesta está enfocada en Florida, por eso incluye el registro en Sunbiz y el fee estatal. Si tu proyecto está en otro estado, cuéntanoslo y revisamos si podemos acompañarte.',
  },
  {
    id: 'ssn-ein',
    question: '¿Necesito tener SSN para obtener un EIN?',
    answer:
      'No siempre: el proceso varía según tu documentación y cada caso se evalúa de forma individual. No ofrecemos asesoría legal ni fiscal; revisamos tu información y te explicamos qué camino aplica para ti.',
  },
  {
    id: 'fee-estatal',
    question: '¿El fee estatal está incluido?',
    answer:
      'Sí. En Lanza tu Empresa, el fee estatal de Florida está incluido en el precio inicial de $597.',
  },
  {
    id: 'tiempos',
    question: '¿Cuánto tarda el proceso?',
    answer:
      'Depende del procesamiento de las entidades gubernamentales y de los servicios que elijas. No garantizamos fechas exactas, pero te mantenemos informada en cada etapa.',
  },
  {
    id: 'todos-los-servicios',
    question: '¿Tengo que contratar todos los servicios?',
    answer:
      'No. Puedes comenzar con lo que necesitas hoy y sumar el resto cuando tu negocio lo requiera.',
  },
  {
    id: 'despues-de-enviar',
    question: '¿Qué sucede después de enviar mi información?',
    answer:
      'Revisamos tus respuestas para entender tu proyecto, identificamos el próximo paso más conveniente y te contactamos para conversarlo.',
  },
]
